export const isProduction = () => process.env.NODE_ENV === "production";

export const isRunningCypress = () => Boolean((window as any).Cypress);
